import * as types from '@store/types'
import graphQL from '@queries'
import ShelvesQuery from '@queries/Shelves'
import store from '@store'

// import { caso_3 } from '@/mocks/fixtures/AwardsShelf'

const state = {
  categoryShelves: [],
  highlightShelf: {},
  partnersShelf: {},
  awardsShelf: {}
}

const isDefaultShelves = (shelve) => {
  const defaultShelves = [
    'Principais Parceiros',
    'Próximos a você',
    'Destaques'
  ]
  if (defaultShelves.includes(shelve.name) || shelve.is_main) return true
  return false
}

const getters = {
  [types.SHELF_PARTNER]: (state) => ({
    ...state.partnersShelf,
    is_main: true,
    campaigns: state.partnersShelf.campaigns && state.partnersShelf.campaigns.map(
      (campaign) => ({
        ...campaign,
        isPartner: true
      })
    )
  }),
  [types.SHELF_HIGHLIGHT]: (state) => ({
    ...state.highlightShelf,
    is_main: true
  }),
  // [types.SHELF_AWARDS]: ({ awardsShelf }) => {
  //   return {
  //     ...awardsShelf,
  //     campaigns: awardsShelf.campaigns && awardsShelf.campaigns.map((campaign) => ({
  //       ...campaign,
  //       isAward: true,
  //       isPartner: false
  //     }))
  //   }
  // },
  [types.SHELVES_CATEGORIES]: (state, getters) => {
    const shelves = state.categoryShelves.map((category) => {
      return {
        ...category,
        campaigns: category.campaigns || [],
        route: {
          name: 'Campanhas',
          query: { category: category.slug }
        }
      }
    })
    shelves.sort(function (first, last) {
      return first.home_order - last.home_order
    })
    return shelves
  },
  [types.SHELVES]: (_, getters) => {
    const partners = getters[types.SHELF_PARTNER]
    const highlight = getters[types.SHELF_HIGHLIGHT]
    const categories = [...getters[types.SHELVES_CATEGORIES]]
    const nextToYou = getters[types.SHELF_PARTNERS_NEARBY]
    // const awards = getters[types.SHELF_AWARDS]

    const shelves = [partners, highlight, nextToYou, ...categories]

    return shelves
  },
  [types.SHELVES_WITH_CAMPAIGNS]: (_, getters) => {
    const hasCampaigns = ({ campaigns }) => campaigns && !!campaigns.length

    const shelves = getters[types.SHELVES].filter(hasCampaigns)

    return shelves.map(shelve => {
      if (shelve.is_home || isDefaultShelves(shelve)) return shelve
    }).filter(shelve => shelve !== undefined)
  },
  [types.SHELVES_FILTERED]: (_, getters) => {
    const hasPermission = permission => {
      const permissions = store.getters[types.COMPANY_PERMISSIONS] || []
      return permissions.some((v) => v === permission)
    }

    return getters[types.SHELVES_WITH_CAMPAIGNS].filter(shelf => {
      return !shelf.permission || hasPermission(shelf.permission)
    })
  }
}

const mutations = {
  [types.SHELVES_CATEGORIES]: (state, payload) => {
    state.categoryShelves = payload
  },
  [types.SHELF_HIGHLIGHT]: (state, payload) => {
    state.highlightShelf = payload
  },
  [types.SHELF_PARTNER]: (state, payload) => {
    state.partnersShelf = payload
  }
  // [types.SHELF_AWARDS]: (state, payload) => {
  //   state.awardsShelf = payload
  // }
}

const actions = {
  [types.SHELVES]: async ({ commit, getters }) => {
    const response = await graphQL(ShelvesQuery, {})
    const categories = response.data.data.categories || []

    const main_category = getters[types.CONFIG_MAIN].main_category
    const categoryName = main_category === 'undefined' ||
      typeof main_category === 'undefined' ||
      main_category === null ||
      main_category.length === 0
      ? 'Principais Parceiros'
      : main_category

    const highlight = {
      menu_icon: 'crown-square',
      name: 'Destaques',
      permission: 'highlight',
      campaigns: (response.data.data.highlight || {}).data || [],
      route: {
        name: 'Campanhas',
        query: { highlight: true }
      }
    }

    const partners = {
      menu_icon: 'cup-square',
      name: categoryName,
      campaigns: response.data.data.partners.data,
      route: {
        name: 'Campanhas'
      }
    }

    // inicio mock awards
    // const retorno = caso_3

    // const awards = {
    //   menu_icon: 'award-star',
    //   name: 'Seu catálogo de prêmios',
    //   campaigns: (retorno && retorno.data) || [],
    //   is_home: true,
    //   isAward: true,
    //   permission: 'awards',
    //   route: {
    //     name: 'Campanhas'
    //   }
    // }
    commit(types.CATEGORIES, categories)
    commit(types.SHELVES_CATEGORIES, categories)
    commit(types.SHELF_HIGHLIGHT, highlight)
    commit(types.SHELF_PARTNER, partners)
    // commit(types.SHELF_AWARDS, awards)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/shelf.js